import React from 'react';
import PropTypes from 'prop-types';

import Grid from '@mui/material/Grid';
import {styled} from '@mui/system';

import {concatUrl} from '../helpers/url';
import {getCall} from '../helpers/request';
import GlobalContext from '../helpers/context';
import ProgressSpinner from '../component/atoms/ProgressSpinner';
import ProfileDetails from '../component/organism/ProfileDetails';


const StyledDetails = styled('div')(({ theme }) =>({
    marginTop: 20,
    marginBottom: 30,
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.fontSize
}));

const StyledNoData = styled('div')(({ theme }) =>({
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.fontSize,
    marginTop: 30,
    marginBottom: 30,
    textAlign: 'center'
}));


class CurationProfileData extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            data: undefined
        };

        this.is_mounted = false;
        this.curation_profile_profile_data_url = concatUrl(window.ROOT_URL, 'api', 'curation_profile', 'profile_data');

    }

    componentDidMount(){
        this.is_mounted = true;
        if (this.props.curation_profile_id){
            this.loadCurationProfileData();
        }
    }

    componentWillUnmount(){
        this.is_mounted = false;
    }

    // +++ load curation profile history +++++++++++++++++++++++++++++++++++++++++++++++

    loadCurationProfileDataFailed = () => {
        if(!this.is_mounted) {
            // skip updating component if not mounted to avoid.
            return;
        }

        this.context.displayGlobalError('Backend service failure: Could not load curation profile details.');
    };

    loadCurationProfileDataDone = (data, callback_failure) => {
        if(!this.is_mounted) {
            // skip updating component if not mounted to avoid.
            return;
        }

        if (!data) {
            callback_failure();
        }else {
            this.setState({
                data: data
            });
        }
    };

    loadCurationProfileData = () => {
        getCall(`${this.curation_profile_profile_data_url}?id=${this.props.curation_profile_id}&workspace_id=${this.props.workspace_id}`,
            this.loadCurationProfileDataDone,
            this.loadCurationProfileDataFailed);
    };

    profileDetails = () => {
        if(this.state.data === undefined) {
            return (
                <Grid container>
                    <Grid size={12}>
                        <ProgressSpinner/>
                    </Grid>
                </Grid>
            );
        }
        if (this.state.data && this.state.data.profile_data){
            return (
                <ProfileDetails profile={this.state.data.profile_data} />
            );
        }
        return (
            <StyledNoData data-bt="profile_details">
                No details available
            </StyledNoData>
        );
    };

    render() {
        return (
            <GlobalContext.Consumer>{() => (
                <StyledDetails>
                    {this.profileDetails()}
                </StyledDetails>
            )}
            </GlobalContext.Consumer>
        );
    }
}

CurationProfileData.contextType = GlobalContext;

CurationProfileData.propTypes = {
    curation_profile_id: PropTypes.number.isRequired,
    workspace_id: PropTypes.number.isRequired
};

export default CurationProfileData;
